import { ComponentProps, ReactNode, useEffect } from 'react';
import { InputLabel } from './InputLabel';

export const TextInput = ({
  value,
  onChange,
  label,
  inputProps,
  className,
  variant = 'default',
  maxLength,
  aside,
}: {
  value: string;
  onChange: (val: string) => any;
  inputProps?: ComponentProps<'input'>;
  label?: ReactNode;
  className?: string;
  variant?: 'default' | 'gray' | 'error';
  maxLength?: number;
  aside?: ReactNode;
}) => {
  useEffect(() => {
    if (typeof maxLength === 'undefined') return;
    if (value.length > maxLength) {
      onChange(value.slice(0, maxLength));
    }
  });

  return (
    <div {...{ className }}>
      <InputLabel {...{ label }} />

      <div
        className={`


          flex items-center

          relative border-2 pl-2 pr-4 pt-[8px] pb-[8px] rounded-lg
          focus-within:border-primary transition-colors

          ${
            {
              default: 'bg-white border-[#e5e7eb]',
              gray: 'bg-[#F1F3F9] focus-within:bg-white border-[transparent]',
              error: 'bg-white border-secondary focus-within:border-secondary',
            }[variant]
          }
        `}
      >
        {aside ? (
          <>
            <div className="ml-[8px] mr-[10px]">{aside}</div>
            <div className="bg-gray-2 opacity-20 h-[15px] w-[3px] mr-[10px]" />
          </>
        ) : null}
        <input
          {...inputProps}
          className={`outline-0 !border-none !p-0 font-medium bg-transparent w-full h-auto ${
            inputProps?.className ?? ''
          }`}
          maxLength={maxLength}
          value={typeof value !== 'undefined' ? `${value}` : ''}
          onChange={(e) => onChange(e.target.value)}
          type="text"
        />
        {typeof maxLength !== 'undefined' ? (
          <span className="absolute right-1 bottom-0 text-gray-400 text-xs z-1">
            {maxLength - value.length}
          </span>
        ) : null}
      </div>
    </div>
  );
};
